import React from 'react';
import ReactDOM from 'react-dom';
import { TooltipProps } from 'react-tooltip';

import { Tooltip, TooltipMain } from './styles';

const GetContent = (args: string) => {
  if (args) {
    const { text } = JSON.parse(args);
    return <div>{text}</div>;
  }
  return <div />;
};

interface ITooltip extends TooltipProps {
  isDashboardTooltip?: boolean;
}

/**
 * Wrapper around react-tooltip component.
 * @param param TooltipProps from react-tooltip
 * @param dashboard - use the dashboard styled blue tooltip - default true
 * @returns
 */
const DashboardPanelTooltip = ({
  id,
  isDashboardTooltip = true,
  ...rest
}: ITooltip): JSX.Element => {
  const TooltipComponent = isDashboardTooltip ? Tooltip : TooltipMain;

  const Tip = () =>
    ReactDOM.createPortal(
      <TooltipComponent
        id={id}
        type="light"
        getContent={GetContent}
        {...rest}
      />,
      document.body,
    );

  return <Tip />;
};

export default DashboardPanelTooltip;
